<template>
    <div class="contents">

        <div v-if="group && !user.is_mega_admin" class="truncate text-white">
            {{ group.name }}
        </div>

        <div v-if="user && user.is_mega_admin">
            <select-menu :text="text" :values="ids" v-model="gid"></select-menu>
        </div>

        <div v-if="user" class="truncate hidden md:flex text-white">
            {{ user.email }}
        </div>

        <form action="/impersonate/1" method="post" v-show="isImpersonated">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="_method" value="delete">
            <button type="submit" class="text-red-500 font-bold">
                MegaMenu
            </button>
        </form>

    </div>
</template>

<script>
import SelectMenu from "../UI/SelectMenu";

export default {
    name: "SuperAdminSwitcher",

    components: {SelectMenu},

    props: ['isImpersonated', 'csrf'],

    inject: ['user', 'group'],

    data: (vm) => ({
        gid: vm.user.group_id,
    }),

    watch: {
        gid(value) {
            window.location.href = `/impersonate?id=${value}`;
        },
    },

    computed: {
        text() {
            return this.user.administrates.map(g => g.name);
        },
        ids() {
            return this.user.administrates.map(g => g.id);
        },
    }
}
</script>

<style scoped>

</style>
